// extracted by mini-css-extract-plugin
module.exports = {"tips":"delete-tips_tips_3l5SM","warnText":"delete-tips_warnText_2rpml"};